
import * as handlebars_family from "../handlebars_family.js";
import "../widget/action-menu.js";
const TPL = handlebars_family.addTemplate("budget/budgetswitch",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <emoji>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji><span>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</span> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<div data-widget=\"widget/action-menu\" data-key=\"budgetswitch\" class=\"h1 large flexrow\" style=\"text-overflow:ellipsis;gap:var(--space)\"> ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"current") || (depth0 != null ? lookupProperty(depth0,"current") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"current","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":136},"end":{"line":1,"column":211}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"current")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " <icon class=\"rotateable\" style=\"font-size:66%\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_chevron_down",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":259},"end":{"line":1,"column":288}}}))
    + "</icon></div>";
},"useData":true});
export default TPL;